var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[
    'UIElement',
    _vm.$style.LayoutSectionAnnotated
  ]},[_c('div',{class:_vm.$style.info},[_c('Heading',{attrs:{"element":"h2"}},[_vm._v(_vm._s(_vm.props.title))]),(_vm.props.description)?_c('div',{class:_vm.$style.description},[_vm._v(_vm._s(_vm.props.description))]):_vm._e()],1),_c('div',{class:_vm.$style.content},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }